/** Form pieces shared by the sign-in, reset and waitlist screens. */

import type { ReactNode } from "react";

export const inputClass =
  "w-full rounded-xl border border-stone-300 bg-white px-4 py-3 text-[15px] text-ink outline-none transition-colors placeholder:text-stone-400 focus:border-leaf-600 focus:ring-2 focus:ring-leaf-100 disabled:bg-stone-50";

export const primaryButtonClass =
  "w-full rounded-xl bg-leaf-700 px-4 py-3 text-[15px] font-semibold text-white transition-colors hover:bg-leaf-800 disabled:cursor-not-allowed disabled:opacity-50";

export function Field({
  label,
  htmlFor,
  children,
}: {
  label: string;
  htmlFor: string;
  children: ReactNode;
}) {
  return (
    <div>
      <label htmlFor={htmlFor} className="mb-2 block text-sm font-medium text-stone-700">
        {label}
      </label>
      {children}
    </div>
  );
}

export function ErrorBox({ message }: { message: string }) {
  return (
    <p role="alert" className="mt-6 rounded-xl bg-red-50 px-4 py-3 text-sm text-red-800">
      {message}
    </p>
  );
}
